import { EventEmitter } from "events";
export const loadingEmitter = new EventEmitter();
